import { getCookie } from './utils/cookie';
import axios from 'axios';

const API = process.env.REACT_APP_API_SERVER;
const SESSION_NAME = process.env.REACT_APP_SESSION_NAME;

const HTTP_CODES = {
  SERVER_ERROR: 500,
  NOT_FOUND: 404,
  BAD_REQUEST: 400
};

const responseHandler = async (response, onFail) => {
  const responseError = Object.values(HTTP_CODES).includes(response.status);

  if (responseError) {
    if (onFail) return onFail();
  }

  let returnValue;
  try {
    returnValue = await response.text();
    returnValue = JSON.parse(returnValue);
  } catch (e) {
    returnValue = response;
  }

  return returnValue;
};

export async function authenticatedRequest(url, options, onFail) {
  // const sessionToken = getCookie(SESSION_NAME);
  const sessionToken = localStorage.getItem("adminToken");
  if (!sessionToken) {
    console.error('No session found');
    return { status: 401, message: 'Not Authenticated' };
  }

  const authenticatedOptions = { ...options };

  if (!authenticatedOptions.headers) {
    authenticatedOptions.headers = {};
  }

  authenticatedOptions.headers['Authorization'] = `Bearer ${sessionToken}`;

  if (options.method !== 'GET' && authenticatedOptions.headers['Content-Type'] === undefined) {
    authenticatedOptions.headers['Content-Type'] = 'application/json';
  }

  let response;
  try {
    response = await fetch(urlFormatter(url), authenticatedOptions);
  } catch (error) {
    if (onFail) return onFail(error);
    return;
  }

  return responseHandler(response, onFail);
}

export async function authenticatedDelete(url, onFail) {
  return authenticatedRequest(url, { method: 'DELETE' }, onFail);
}

export async function authenticatedFetch(url, onFail) {
  return authenticatedRequest(url, { method: 'GET' }, onFail);
}

// export async function authenticatedPost(url, onFail, payload = null) {
//     return authenticatedRequest(url, { method: 'POST', body: payload ? JSON.stringify(payload) : null }, onFail);
// }

// export async function authenticatedPost(url, onFail, data) {
//   try {
//     const headers = {};

//     // Automatically set multipart/form-data for FormData
//     if (data instanceof FormData) {
//       headers['Content-Type'] = 'multipart/form-data';
//     }

//     const response = await axios.post(url, data, { headers });
//     return response.data;
//   } catch (err) {
//     if (onFail) onFail(err);
//     return false;
//   }
// }

export async function authenticatedPost(url, onFail, data) {
  try {
    const headers = {};

    // ✅ Automatically set multipart/form-data for FormData
    if (data instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    // ✅ Add Authorization header from localStorage
    const token = localStorage.getItem('adminToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.post(urlFormatter(url), data, { headers });
    return response.data;
  } catch (err) {
    if (onFail) onFail(err);
    return false;
  }
}
  


export async function authenticatedPut(url, onFail, payload = null) {
  return authenticatedRequest(url, { method: 'PUT', body: payload ? JSON.stringify(payload) : null }, onFail);
}

// export async function authenticatedPatch(url, onFail, payload = null) {
//     return authenticatedRequest(url, { method: 'PATCH', body: payload ? JSON.stringify(payload) : null }, onFail);
// }

// export async function authenticatedPatch(url, onFail, data) {
//   try {
//     const headers = {};

//     if (data instanceof FormData) {
//       headers['Content-Type'] = 'multipart/form-data';
//     }
//     for (let [key, value] of data.entries()) {
//       console.log(`${key}:`, value);
//     }
//     console.log('response')
//     const response = await axios.patch(urlFormatter(url), data, { headers });
//     console.log("responseee")
//     return response.data;
//   } catch (err) {
//     console.error("PATCH request failed:", err); // ✅ ADD THIS

//     if (onFail) onFail(err);

//     return false;
//   }
// }

export async function authenticatedPatch(url, onFail, data) {
  try {
    const headers = {};

    if (data instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    // ✅ Directly get token from localStorage
    const token = localStorage.getItem('adminToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.patch(urlFormatter(url), data, { headers });
    console.log("responseee");
    return response.data;
  } catch (err) {
    console.error("PATCH request failed:", err.response?.data || err);
    if (onFail) onFail(err);
    return false;
  }
}



export async function authenticatedSubscriptionList(url) {
  return authenticatedRequest(url, { method: "GET" })
}

export const urlFormatter = (path) => {
  if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
    return path;
  }
  return `${API}${path}`;
};


// use plain fetch without token
export const unauthenticatedPost = async (url, payload = null, onFail) => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const res = await fetch(urlFormatter(url), {
      method: 'POST',
      headers,
      body: payload ? JSON.stringify(payload) : null
    });
    return await responseHandler(res, onFail);
  } catch (err) {
    if (onFail) return onFail(err);
    return;
  }
};
